import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signup, loginByGoogle, loginByYahoo } from "../../redux/slices/auth";
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
import LOGO from "../../assets/images/auth/logo-sevenly.png";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { toast } from "react-toastify";
import InputBox from "../../components/AuthInpt";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Spinner from "../../components/Spinner";
import YahooButton from "../../assets/images/auth/yahoologin.png";
const Signup = () => {
  const {referral} = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [userId, setUserId] = useState("");
  const { user, token, error, loading } = useSelector((state) => state.auth);
  const [emailError, setEmailError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConPassword, setShowConPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const redirectUriSignup = window.location.origin + window.location.pathname;
  useEffect(() => {
    if (token) {
      // dispatch(fetchUser());
      navigate("/");
      toast.success("Welcome to Sevenly travel!");
    }
    if (error);
    {
      toast.error(error);
    }
  }, [token, error]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    const state = queryParams.get("state");

    if (code) {
      // We have a code from Yahoo; now exchange it for tokens
      exchangeCodeForTokens(code);
    } else {
      localStorage.removeItem("yahoo_oauth_state");
      localStorage.removeItem("yahoo_code_verifier");
    }
  }, [location]);

  const handleContinue = () => {
    if (email !== "" && email !== undefined && email !== null) {
      setLoader(true);
      axios
        .post(process.env.REACT_APP_BACKEND + "auth/signup", { email: email, referral: referral })
        .then((resp) => {
          setTabValue(1);
          setUserId(resp.data.data.userId);
          toast.success(resp.data.message);
          setLoader(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setLoader(false);
        });
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const credentials = {
      name: name,
      pass: password,
      confirmPass: confirmPassword,
      email: email,
      _id: userId,
      otp: otp,
    };

    dispatch(signup(credentials));
  };
  const handleLoginSuccess = (credentialResponse) => {
    const data = { tokenId: credentialResponse?.credential };
    dispatch(loginByGoogle(data));
  };

  const handleLoginFailure = () => {
    console.log("Login Failed");
  };
  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);

    // Skip validation if the email is empty
    if (emailValue === "") {
      setEmailError("");
      return;
    }

    // Simple email regex pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Validate the email format
    if (!emailPattern.test(emailValue)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  const generateRandomString = (length) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };

  // Utility to compute code_challenge from code_verifier
  const generateCodeChallenge = async (codeVerifier) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const handleYahooLogin = async () => {
    const clientId = process.env.REACT_APP_YAHOO_CLIENT_ID;
    const scope = "openid email profile";
    const state = Math.random().toString(36).substring(2); // CSRF protection
    const codeVerifier = generateRandomString(43); // 43-128 chars
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    const authUrl = `https://api.login.yahoo.com/oauth2/request_auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUriSignup
    )}&response_type=code&scope=${encodeURIComponent(
      scope
    )}&state=${state}&code_challenge=${encodeURIComponent(
      codeChallenge
    )}&code_challenge_method=S256`;

    // Store state and code_verifier
    localStorage.setItem("yahoo_oauth_state", state);
    localStorage.setItem("yahoo_code_verifier", codeVerifier);

    window.location.href = authUrl;
  };

  const exchangeCodeForTokens = async (code) => {
    try {
      // Retrieve the code_verifier from sessionStorage
      const codeVerifier = localStorage.getItem("yahoo_code_verifier");
      if (!codeVerifier) {
        throw new Error("Error.");
      }

      const bodyParams = {
        code: code,
        code_verifier: codeVerifier,
        redirect_uri: redirectUriSignup,
      };
      dispatch(loginByYahoo(bodyParams));
    } catch (err) {
      toast.error("Please refresh and retry.");
      console.error("Error exchanging code for tokens", err);
    }
  };

  return (
    <div className="logincont">
      <div
        className="bx-shadow-large w30 mt-5 d-flex align-items-center justify-content-center flex-column "
        style={{
          background: "var(--black-color)",
          borderRadius: "8px",
          color: "var(--white-color)",
          padding: "20px 50px",
          zIndex: "111",
        }}
      >
        <img
          className="my-4 c-pointer w20"
          onClick={() => navigate("/")}
          style={{ height: "auto" }}
          src={LOGO}
        />
        <h1 className="mb-3">
          Welcome to {" "}
          <span style={{ color: "var(--primary-color)" }}>Sevenly Travel </span>
        </h1>
        {tabValue == 0 && (
          <>
            <div>
              <TextField
                id="outlined-basic"
                label="Email"
                variant="outlined"
                fullWidth
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "white",
                    },
                    "&:hover fieldset": {
                      borderColor: "white",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "white",
                    },
                    borderRadius: "50px",
                    color: "white",
                  },
                  "& .MuiInputLabel-root": {
                    color: "white",
                    fontFamily: "'Poppins', sans-serif",
                    "&.Mui-focused": {
                      color: "white",
                    },
                  },
                  input: {
                    color: "white",
                    fontFamily: "'Poppins', sans-serif",
                  },
                }}
              />

              {/* <InputBox
                label="Enter your email"
                id="name"
                type="email"
                value={email}
                onChange={handleEmailChange}
                helperText={emailError}
                error={emailError}
                style={{ width: "90%" }}
              /> */}

              <p className="fs-8 mt-2" style={{ textAlign: "right" }}>
                By continuing, I acknowledge the{" "}
                <span
                  className="c-pointer"
                  style={{ color: "var(--primary-color)" }}
                  onClick={() => navigate("/privacy-policy")}
                >
                   Sevenly Privacy Policy.
                </span>
              </p>
            </div>

            <button
              className="btn-contained mt-4 d-flex align-items-center justify-content-center"
              style={{ borderRadius: "50px", gap: "10px" }}
              onClick={handleContinue}
            >
              Continue
              {loader && <Spinner />}
            </button>
            <p className="my-3">
              Already have an account?{" "}
              <Link to="/login" style={{ color: "var(--primary-color)" }}>
                {" "}
                Sign in{" "}
              </Link>{" "}
            </p>
            <div className="mb-4">
              <GoogleLogin
                onSuccess={handleLoginSuccess}
                onError={handleLoginFailure}
                className="custom-google-login-button"
                shape="circle"
                size="large"
                width="200px"
              />
            </div>
            <div className="mb-4">
              <img
                src={YahooButton}
                alt="Sign in with Yahoo"
                onClick={handleYahooLogin}
                style={{
                  width: "200px",
                  height: "40px",
                  cursor: "pointer",
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }}
              />
            </div>
          </>
        )}
        {tabValue == 1 && (
          <>
            <TextField
              id="outlined-basic"
              label="Otp"
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                  borderRadius: "50px",
                  color: "white",
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                  "&.Mui-focused": {
                    color: "white",
                  },
                },
                input: {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                },
              }}
              className="my-4"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <TextField
              id="outlined-basic"
              label="Name"
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                  borderRadius: "50px",
                  color: "white",
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                  "&.Mui-focused": {
                    color: "white",
                  },
                },
                input: {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                },
              }}
              className="mb-4"
            />
            <TextField
              id="outlined-basic"
              label="Password"
              variant="outlined"
              fullWidth
              value={password}
              type={showPassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                  borderRadius: "50px",
                  color: "white",
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                  "&.Mui-focused": {
                    color: "white",
                  },
                },
                input: {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      style={{ color: "white" }}
                    >
                      {showPassword ? (
                        <VisibilityOff style={{ color: "#FFF" }} />
                      ) : (
                        <Visibility style={{ color: "#FFF" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              className="mb-4"
            />
            <TextField
              id="outlined-basic"
              label="Re-enter password"
              variant="outlined"
              fullWidth
              value={confirmPassword}
              type={showConPassword ? "text" : "password"}
              onChange={(e) => setConfirmPassword(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                  borderRadius: "50px",
                  color: "white",
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                  "&.Mui-focused": {
                    color: "white",
                  },
                },
                input: {
                  color: "white",
                  fontFamily: "'Poppins', sans-serif",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConPassword(!showConPassword)}
                      edge="end"
                      style={{ color: "white" }}
                    >
                      {showConPassword ? (
                        <VisibilityOff style={{ color: "#FFF" }} />
                      ) : (
                        <Visibility style={{ color: "#FFF" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              className="mb-4"
            />
            <button
              className="btn-contained  mb-4 w40"
              style={{ borderRadius: "50px" }}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Signup;
